import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ProcessHero from './components/ProcessHero';
import ProcessSteps from './components/ProcessSteps';
import ProcessBenefits from './components/ProcessBenefits';

const ComoFuncionaPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ProcessHero />
        <ProcessSteps />
        <ProcessBenefits />
      </main>
      <Footer />
    </div>
  );
};

export default ComoFuncionaPage;